import React, { Component } from 'react';
import _ from 'lodash';

import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';

import { usersList } from '../actions/usersActions';
import { UserBody } from '../types/UsersBody';

import { withStyles } from '@material-ui/core/styles';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import {
	WithStyles,
	createStyles,
	Grid,
	Button,
} from '@material-ui/core';
import {
	Settings as SettingsIcon,
	MoreVert as MoreIcon
} from '@material-ui/icons';

import {
	MyPATPopMenu,
	MenuData
} from '../../common';

// container
import UserGroupsContainer from './UserGroupsContainer';
import UsersContainer from './UsersContainer';
import UserRolesContainer from './UserRolesContainer';
import MiniLibrariesContainer from './MiniLibrariesContainer';

// add dialog
import AddUserGroupDialog from '../components/AddUserGroupDialog';
import AssignRoleDialog from '../components/AssignRoleDialog';
import CreateRoleDialog from '../components/CreateRoleDialog';
import AddMiniLibraryDialog from '../components/AddMiniLibraryDialog';
import AddUserDialogOpen from '../components/AddUserDialog';
import UserProfileCard from '../components/UserProfileCard';

import { getRolesCount } from '../actions/userRoleAction';
import { getUserCount } from '../actions/usersActions';
import { UserRoleList, getRolesEnumType } from '../actions/userRoleAction';
import { rolesEnum } from '../types/RolesEnumBody';
import { getMiniLibraryCount } from '../actions/miniLibrariesActions';
import { getUserGroupsCount, userGroupsList } from '../actions/userGroupsActions';
import { UserGroupsBody } from '../types/UserGroupsBody';
import { miniLibraryList } from '../actions/miniLibrariesActions';
import ACL from '../../acl/components/ACL';
const styles = (theme: Theme) => createStyles({
	header: {
		padding: `${theme.spacing.unit}px 0`,
	},

	navigation: {
		display: 'flex',
		alignItems: 'center',
		width: '100%',
		padding: 0,
		margin: 0,

		'& > li': {
			display: 'inline-flex',
			alignItems: 'center',
			marginRight: theme.spacing.unit * 2,
			'&:last-child': {
				marginRight: 0,
			},
			'&.active > a': {
				color: theme.palette.text.primary,
			},

			'& > a': {
				...theme.typography.h6,
				color: theme.palette.grey[500],
				textDecoration: 'none',
				display: 'inline-block',
				transition: 'all 0.2s linear',
			}
		}
	}
});

interface UserManagementContainerProps extends WithStyles<typeof styles> {
	users: UserBody[],
	userGroups: {
		list: UserGroupsBody[],
		count: number,
	},
	usersList: Function,
	UserRoleList: () => void,
	getMiniLibraryCount: () => void,
	getUserGroupsCount: () => void,
	getUserCount: () => void,
	getRolesCount: () => void,
	getRolesEnumType: () => void,
	userGroupsList: () => void,
	miniLibraryCount: number,
	userCount: number,
	rolesCount: number,
	enumRoles: rolesEnum[],
	miniLibraryList: () => void,
	history: any,
}

interface UserManagementContainerState {
	activeNav: string | "userGroups" | "users" | "roles" | "miniLibraries",
	addUserGroupDialogOpen: boolean,
	editUserGroupId: string,
	addUserDialogOpen: boolean,
	editMiniLibraryId: string,
	assignRoleDialogOpen: boolean,
	createRoleDialogOpen: boolean,
	addMiniLibraryDialogOpen: boolean,
	usersContainer: {
		assignRoleDialogOpen: boolean,
		selectedUserId: string,
		showUserProfile: boolean,
		selectedUserProfile: any
	},

	// enumRoles: rolesEnum,
}

class UserManagementContainer extends Component<UserManagementContainerProps, UserManagementContainerState> {
	constructor(props: UserManagementContainerProps) {
		super(props);
		this.state = {
			activeNav: "",
			addUserGroupDialogOpen: false,
			editUserGroupId: '',
			editMiniLibraryId: '',
			addUserDialogOpen: false,
			assignRoleDialogOpen: false,
			createRoleDialogOpen: false,
			addMiniLibraryDialogOpen: false,
			usersContainer: {
				assignRoleDialogOpen: false,
				selectedUserId: "",
				showUserProfile: false,
				selectedUserProfile: {}
			}
			// enumRoles: {}
		};

		this.handleNavigationClick = this.handleNavigationClick.bind(this);
		this.handleDialogOpen = this.handleDialogOpen.bind(this);
		this.handleAddDialogOpen = this.handleAddDialogOpen.bind(this);
		this.handleUserGroupEdit = this.handleUserGroupEdit.bind(this);
		this.handleDialogClose = this.handleDialogClose.bind(this);
		this.userContainerHandleButtonPress = this.userContainerHandleButtonPress.bind(this)
		this.userContainerHandleButtonRelease = this.userContainerHandleButtonRelease.bind(this)
		this.userContainerHandleDialogClose = this.userContainerHandleDialogClose.bind(this);
		this.userContainerShowUserProfile = this.userContainerShowUserProfile.bind(this);
		this.userContainerHandleUserProfileClose = this.userContainerHandleUserProfileClose.bind(this);
		this.handleAssignDialogue = this.handleAssignDialogue.bind(this);

	}
	buttonPressTimer: any;

	componentDidMount() {
		this.setState({ activeNav: "userGroups" });
		this.usersInit();
		this.userGroupsInit();
		this.rolesInit();
		this.miniLibraryInit();

		_.isEmpty(this.props.userGroups.list) && this.props.userGroupsList();
	}

	rolesInit() {
		this.props.UserRoleList();
		this.props.getRolesCount();
		this.props.getRolesEnumType();
	}

	usersInit = () => {
		this.props.usersList();
		this.props.getUserCount();
	}

	userGroupsInit = () => {
		this.props.getUserGroupsCount();
	}

	miniLibraryInit = () => {
		this.props.getMiniLibraryCount();
		this.props.miniLibraryList();
	}

	settingsMenuItems: MenuData[] = [{
		type: 'redirect',
		id: 1,
		to: '/user-management',
		img: "/assets/img/mylibrary/settingsMenu/tag-icon.png",
		text: 'Settings Menu Text'
	}];

	moreMenuItems: MenuData[] = [{
		type: 'redirect',
		id: 1,
		to: '/user-management',
		img: "/assets/img/mylibrary/settingsMenu/tag-icon.png",
		text: 'More Menu Text'
	}];

	handleNavigationClick = (activeNav: string) => this.setState({ activeNav });

	handleDialogOpen = (activeNav: string) => {
		this.setState({
			addUserGroupDialogOpen: _.isEqual(activeNav, 'userGroups'),
			assignRoleDialogOpen: _.isEqual(activeNav, 'users'),
			addUserDialogOpen: _.isEqual(activeNav, 'addUser'),
			createRoleDialogOpen: _.isEqual(activeNav, 'roles'),
			addMiniLibraryDialogOpen: _.isEqual(activeNav, 'miniLibraries'),
		});
	}

	handleAddDialogOpen = (activeNav: string) => {
		this.setState({
			editUserGroupId: '',
			editMiniLibraryId: '',
		});
		this.handleDialogOpen(activeNav);
	}

	handleUserGroupEdit = (evt: any) => {
		this.setState({ editUserGroupId: evt.currentTarget.id });
		this.handleDialogOpen('userGroups');
	}

	handleMiniLibraryEdit = (evt: any) => {
		this.setState({ editMiniLibraryId: evt.currentTarget.id });
		this.handleDialogOpen('miniLibraries');
	}

	handleDialogClose = (activeNav: string) => {
		this.setState({
			addUserGroupDialogOpen: _.isEqual(activeNav, 'userGroups') && false,
			assignRoleDialogOpen: _.isEqual(activeNav, 'users') && false,
			addUserDialogOpen: _.isEqual(activeNav, 'addUser') && false,
			createRoleDialogOpen: _.isEqual(activeNav, 'roles') && false,
			addMiniLibraryDialogOpen: _.isEqual(activeNav, 'miniLibraries') && false,
		});
		_.isEqual(activeNav, 'addUser') && this.props.usersList() && this.props.userGroupsList();
	}

	userContainerHandleButtonPress(userId: string, e: any) {
		e.stopPropagation();
		this.buttonPressTimer =
			setTimeout(() => {
				// alert(`long press activated ${userId}`)
				this.setState((prevState: any) => ({ usersContainer: { ...prevState.usersContainer, selectedUserId: userId, assignRoleDialogOpen: true } }));
			}, 1000);
	}

	userContainerHandleButtonRelease() {
		clearTimeout(this.buttonPressTimer);
	}

	userContainerShowUserProfile = (userProfile: any, e: any) => this.setState((prevState: any) => ({ usersContainer: { ...prevState.usersContainer, selectedUserProfile: userProfile, selectedUserId: userProfile._id, showUserProfile: true } }));

	userContainerHandleDialogClose = () => {
		this.setState((prevState: any) => ({ usersContainer: { ...prevState.usersContainer, assignRoleDialogOpen: false, } }))
	};

	userContainerHandleUserProfileClose = () => {
		this.setState((prevState: any) => ({ usersContainer: { ...prevState.usersContainer, showUserProfile: false, selectedUserProfile: {} } }));
		this.props.usersList();
		this.props.userGroupsList();
		this.props.getUserCount();
	};

	userDialogEvent() {
		this.setState({ addUserDialogOpen: false });
		this.props.usersList();
		this.props.userGroupsList();
		this.props.getUserCount();
	}

	handleAssignDialogue = (isOpen: boolean, e: any) => {
		this.setState((prevState: any) => ({ usersContainer: { ...prevState.usersContainer, assignRoleDialogOpen: isOpen } }))
	};


	render() {
		const {
			classes,
			miniLibraryCount,
			userCount,
			rolesCount,
			userGroups,
			history,
		} = this.props;
		const {
			activeNav,
			addUserGroupDialogOpen,
			editUserGroupId,
			editMiniLibraryId,
			createRoleDialogOpen,
			addMiniLibraryDialogOpen,
			addUserDialogOpen,
			usersContainer: { assignRoleDialogOpen, selectedUserId, showUserProfile, selectedUserProfile }
		} = this.state;

		const AddButton = () => {
			switch (activeNav) {
				case 'users': {
					return (

							<Button variant="contained" color="primary" onClick={this.handleDialogOpen.bind(this, 'addUser')}>
								Add User
							</Button>
					);
				}
				case 'roles': {
					return (

							<Button variant="contained" color="primary" onClick={this.handleAddDialogOpen.bind(this, activeNav)}>
								Create Role
						</Button>
					);
				}
				// case 'miniLibraries': {
				// 	return (

				// 			<Button variant="contained" color="primary" onClick={this.handleAddDialogOpen.bind(this, activeNav)}>
				// 				Add Mini Library
				// 		</Button>
				// 	);
				// }
				default: {
					return (

							<Button variant="contained" color="primary" onClick={this.handleAddDialogOpen.bind(this, activeNav)}>
								Add User Group
						</Button>
					);
				}
			}
		};

		const ContentWrapper = () => {
			switch (activeNav) {
				case 'users': {
					return <UsersContainer
						handleButtonPress={this.userContainerHandleButtonPress}
						handleButtonRelease={this.userContainerHandleButtonRelease}
						handleDialogClose={this.userContainerHandleDialogClose}
						handleShowUserProfile={this.userContainerShowUserProfile}
						handleUserProfileClose={this.userContainerHandleUserProfileClose}
						handleAssignDialogue={this.handleAssignDialogue}
						{...this.state.usersContainer}
					/>;
				}
				case 'roles': {
					return <UserRolesContainer />;
				}
				case 'miniLibraries': {
					return (
						<>
							<MiniLibrariesContainer
								onEditClick={this.handleMiniLibraryEdit.bind(this)}
								history={history}
							/>
							<AddMiniLibraryDialog
								dialogOpen={addMiniLibraryDialogOpen}
								dialogCloseHandler={this.handleDialogClose.bind(this, activeNav)}
								dialogData={editMiniLibraryId}
							/>
						</>
					);
				}
				default: {
					return (
						<>
							<UserGroupsContainer
								onEditClick={this.handleUserGroupEdit.bind(this)}
								handleDialogClose={this.userContainerHandleDialogClose}
								handleShowUserProfile={this.userContainerShowUserProfile}
								assignRoleDialogOpen={assignRoleDialogOpen}
								selectedUserId={selectedUserId}
							/>
							<AddUserGroupDialog
								dialogOpen={addUserGroupDialogOpen}
								dialogCloseHandler={this.handleDialogClose.bind(this, activeNav)}
								dialogData={editUserGroupId}
							/>
						</>
					);
				}
			}
		}

		return (
			<>
				<Grid container spacing={16} alignItems="center" className={classes.header}>
					<Grid item xs>
						<ul className={classes.navigation}>

								<li className={_.isEqual(activeNav, 'userGroups') ? "active" : ""}>
									<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'userGroups')}>
										User Groups ({userGroups.count})
								</a>
								</li>
								<li className={_.isEqual(activeNav, 'users') ? "active" : ""}>
									<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'users')}>
										Users ({userCount})
								</a>
								</li>
								<li className={_.isEqual(activeNav, 'roles') ? "active" : ""}>
									<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'roles')}>
										Roles ({rolesCount})
								</a>
								</li>

								<li className={_.isEqual(activeNav, 'miniLibraries') ? "active" : ""}>
									<a href="javascript:void(0)" onClick={this.handleNavigationClick.bind(this, 'miniLibraries')}>
										Mini-Libraries ({miniLibraryCount})
								</a>
								</li>
						</ul>
					</Grid>
					<Grid item xs="auto">
						<AddButton />
					</Grid>
					<Grid item xs="auto">
						<MyPATPopMenu id="settings-menu" icon={SettingsIcon} menuItem={this.settingsMenuItems} />
					</Grid>
					<Grid item xs="auto">
						<MyPATPopMenu id="more-menu" icon={MoreIcon} menuItem={this.moreMenuItems} />
					</Grid>
				</Grid>

				<Grid container>
					<Grid item xs={12}>
						<ContentWrapper />
					</Grid>
				</Grid>

				{showUserProfile &&
					<UserProfileCard
						handleAssignDialogue={this.handleAssignDialogue}
						assignRoleDialogOpen={assignRoleDialogOpen}
						dialogOpen={showUserProfile}
						userProfile={selectedUserProfile}
						onClose={this.userContainerHandleUserProfileClose}
					/>
				}

				{addUserDialogOpen &&
					<AddUserDialogOpen
						dialogOpen={addUserDialogOpen}
						isDone={this.userDialogEvent.bind(this)}
						dialogCloseHandler={this.handleDialogClose.bind(this, 'addUser')}
					/>
				}
				<AssignRoleDialog
					dialogOpen={assignRoleDialogOpen}
					assignRoleUserId={selectedUserId}
					dialogCloseHandler={this.userContainerHandleDialogClose}
				/>

				<CreateRoleDialog
					dialogOpen={createRoleDialogOpen}
					dialogCloseHandler={this.handleDialogClose.bind(this, activeNav)}
				/>
			</>
		);
	}
}

const mapStateToProps = (state: any) => ({
	users: _.get(state, 'userManagement.users.list', []),
	userGroups: _.get(state, 'userManagement.userGroups', {}),
	miniLibraryCount: _.get(state, 'userManagement.miniLibrary.count', 0),
	userGroupsCount: _.get(state, 'userManagement.userGroups.count', 0),
	userCount: _.get(state, 'userManagement.users.count', 0),
	rolesCount: _.get(state, 'userManagement.userRoleList.count', 0),
	enumRoles: _.get(state, 'userManagement.userRoleList.enumList', [])
});

const mapDispatchToProps = (dispatch: any) => bindActionCreators({
	usersList,
	UserRoleList,
	getMiniLibraryCount,
	getUserGroupsCount,
	getUserCount,
	getRolesCount,
	getRolesEnumType,
	userGroupsList,
	miniLibraryList,
}, dispatch);

// @ts-ignore
export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(UserManagementContainer));